module.exports = __webpack_public_path__ + "assets/img/chevron-right-circle-green.64eab6e5.svg";